module.exports = __webpack_public_path__ + "media/images/flag_en-d252e695b54830d545bac7bf135adee8.png";